/**
 * Returns the API root URL with protocol ensured.
 * Render's hostport property returns hostname:port without protocol,
 * so we need to prepend https:// if missing.
 */
export function getApiRoot() {
  let url = import.meta.env.VITE_API_ENDPOINT || "";
  if (url && !url.match(/^https?:\/\//)) {
    url = "https://" + url;
  }
  return url;
}
